import React from "react"

import { AppCardTitle, AppCrudTable } from "@components"
import { userSettingAcrissData } from "../../../@signals"
import { actionsColumn, colorColumn, nameColumn } from "./columns"
import { isTourDemoActive } from "@signals/app"
import UserSettingsAcrissTabButton from "../Button"

export default function UserSettingsAcrissTable() {
	if (isTourDemoActive.value && !userSettingAcrissData.value?.length) return null
    return <AppCrudTable
		// The tab's create button with the table's own actions, as every list of the app
		options={{ customToolbar: () => <UserSettingsAcrissTabButton/> }}
		title={<AppCardTitle icon="palette" title="Your ACRISS Colors"/>}
		data={userSettingAcrissData.value}
		columns={[
			nameColumn(),
			colorColumn(),
			actionsColumn()
		]}
	/>
}